export default "__VITE_ASSET__BQua2f57__"